/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
  SignatureData,
  TaskDataImageExtended,
  TaskDataImagePng,
  TaskDataImageUrl,
  TaskDataSignature,
  TaskDatumType
} from '../../../../../../../models/task.model';
import { Logger, LogService } from '@epg/angular-base-lib';
import { ApiService } from '../../../../../../../services/api.service';
import { attachCompanyNameToUrl, hasUUIDInUrl } from '../../../../../../../app/shared/functions';

@Component({
  selector: 'app-signature-item',
  templateUrl: './signature-item.component.html',
  styleUrls: ['./signature-item.component.scss'],
  standalone: false
})
export class SignatureItemComponent implements OnInit {
  @Input() signatureItem: TaskDataSignature = new TaskDataSignature(
    new SignatureData(new TaskDataImagePng(''))
  );
  imageUrl: string = '';

  private log: Logger;

  constructor(
    logService: LogService,
    private apiService: ApiService
  ) {
    this.log = logService.getLogger(this);
  }

  ngOnInit(): void {
    this.log.debug(this.signatureItem.value.image.value);
    let image = this.signatureItem.value.image;

    if (image.type == TaskDatumType.EXTENDED_IMAGE) {
      image = (image as TaskDataImageExtended).value.image;
    }

    switch (image.type) {
      case TaskDatumType.IMAGE_URL:
        let url = attachCompanyNameToUrl((image as TaskDataImageUrl).value);
        const separator = url.includes('?') ? '&' : '?';
        if (hasUUIDInUrl(url)) {
          url = `${url}${separator}returnType=direct`;
        }
        this.imageUrl = url;
        break;
      case TaskDatumType.IMAGE_JPEG:
        this.imageUrl = `data:image/jpeg;base64,${image.value}`;
        break;
      case TaskDatumType.IMAGE_PNG:
        this.imageUrl = `data:image/png;base64,${image.value}`;
        break;
    }
    this.log.debug(this.imageUrl);
  }
}
